import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_ITEMS, BRAND } from "../lib/content";
import BrandMark from "./BrandMark";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`bjc-header sticky top-0 z-50 ${scrolled ? "shadow-[0_1px_0_rgba(255,255,255,0.06)]" : ""}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-24 md:h-28">
          <Link
            to="/"
            data-testid="brand-logo-link"
            className="flex items-center group py-2"
          >
            <BrandMark height={84} className="opacity-95 group-hover:opacity-100 transition-opacity" />
          </Link>

          <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) => `bjc-nav-link ${isActive ? "active" : ""}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link to="/contact" data-testid="header-speak-cta" className="bjc-btn-primary">
              Speak With Us
            </Link>
          </div>

          <button
            type="button"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 border border-[var(--bjc-border-strong)] text-[var(--bjc-text)] hover:border-[var(--bjc-gold)] hover:text-[var(--bjc-gold)] transition-colors"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[var(--bjc-border)] bg-[var(--bjc-bg)]" data-testid="mobile-nav">
          <div className="max-w-[1400px] mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) => `bjc-nav-link ${isActive ? "active" : ""}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="mobile-speak-cta"
              className="bjc-btn-primary justify-center mt-2"
            >
              Speak With Us
            </Link>
            <span className="text-[11px] tracking-[0.2em] uppercase text-[var(--bjc-text-faint)] pt-2">
              {BRAND.email}
            </span>
          </div>
        </div>
      )}
    </header>
  );
}
